module.exports = __webpack_public_path__ + "e96b48eb2c21f206064588517bf486ab.png";